<template>
  <date-time-picker :value="value" @update:data="(data) => $emit('update:data', data)"></date-time-picker>
</template>

<script>
import DateTimePicker from '@kanrisha/components/Elements/DateTimePicker';

export default {
  components: {
    DateTimePicker,
  },
  props: {
    value: { type: String, default: '' },
  },
  emits: ['update:data'],
  setup() {},
};
</script>
